import { Translator } from "Translator";
import { SubOption } from "model/Filters";

const transportationModeSubOptions = [
  {
    id: 150,
    queryValue: 'walkingtour',
    value: 'walking',
    name: Translator.translate('Experience.TransportMode.walking', {}, true, 'Walking'),
  },
  {
    id: 151,
    queryValue: 'boattour',
    value: 'boat',
    name: Translator.translate('Experience.TransportMode.boat', {}, true, 'Boat'),
  },
  {
    id: 152,
    queryValue: 'bicycletour',
    value: 'bike',
    name: Translator.translate('Experience.TransportMode.bike', {}, true, 'Bike'),
  },
  {
    id: 153,
    queryValue: 'motortour',
    value: 'motor',
    name: Translator.translate('Experience.TransportMode.motor', {}, true, 'Motor'),
  },
  {
    id: 154,
    value: 'car',
    name: Translator.translate('Experience.TransportMode.car', {}, true, 'Car'),
  },
  {
    id: 155,
    queryValue: 'tuktuk',
    value: 'tuk-tuk',
    name: Translator.translate('Experience.TransportMode.tuktuk', {}, true, 'Tuk tuk'),
  },
  {
    id: 156,
    queryValue: 'publictransport',
    value: 'public-transport',
    name: Translator.translate('Experience.TransportMode.publicTransport', {}, true, 'Public transport'),
  },
] as SubOption[];


export default transportationModeSubOptions;
